/**
 * Cleans a phone number by removing all special characters, spaces, and formatting
 * @param phoneNumber - The phone number string to clean
 * @returns The cleaned phone number with only digits
 */
export const cleanPhoneNumber = (phoneNumber: string): string => {
    if (!phoneNumber) return '';

    // Remove all non-digit characters
    return phoneNumber.replace(/\D/g, '');
};

/**
 * Detects if a query string looks like a phone number
 * @param query - The search query string
 * @returns true if the query appears to be a phone number
 */
export const isPhoneNumberQuery = (query: string): boolean => {
    if (!query) return false;

    // If there are no letters, assume it's a phone number
    const hasLetters = /[a-zA-Z]/.test(query);
    return !hasLetters;
};

/**
 * Cleans a search query based on whether it's a phone number or text
 * @param query - The search query string
 * @returns The cleaned query string
 */
export const cleanSearchQuery = (query: string): string => {
    if (!query) return '';

    if (isPhoneNumberQuery(query)) {
        return cleanPhoneNumber(query);
    }

    // For text queries, preserve spaces and most characters
    return query.trim();
};

export default cleanSearchQuery;
